import { useState, useEffect, useContext, useMemo, useRef, forwardRef, useImperativeHandle } from "react";
import styles from './index.module.scss'
import { Button, Modal, message, Popover } from 'antd';
import { Tabs } from 'antd';
import API from '@api/api'
import Utils from '@utils/utils'
import SelectionFilter from './SelectionFilter'
import { ProjectContext } from '../../hooks/ProjectContext';
import Iconfont from '@utils/Iconfont';
import {
    RESOURCE_PARAMS,
    RESOURCE_TYPE,
    IMAGE_TYPE,
    GENERATE_MODE
} from "@utils/CONST"
import { AppContext } from '@utils/AppContext';
import { workflowOfChange } from '@utils/workflowOfBuildTaskV2'

const ChangeModelAndBg = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        handleClick
    }))
    const {
        resourceFilter,
        setResourceFilter
    } = useContext(ProjectContext)
    const { setGlobalTaskReadFlag } = useContext(AppContext)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modelList, setModelList] = useState([])
    const [bgList, setBgList] = useState([])
    const [customModelList, setCustomModelList] = useState([])
    const [customBgList, setCustomBgList] = useState([])
    const [tryonVideoList, setTryonVideoList] = useState([])
    const [item, setItem] = useState()
    const [tabKey, setTabKey] = useState('1')
    const [showType, setShowType] = useState()
    const [selectItemId, setSelectItemId] = useState()
    const [selectItemObj, setSelectItemObj] = useState({})
    const [selectCurrentItem, setSelectCurrentItem] = useState({})

    const tabItem = useMemo(() => {
        if (item?.imageType == IMAGE_TYPE.CLOTHES) {
            return [
                {
                    key: '1',
                    label: showType == 'bg' ? '预设背景' : '预设模特',
                }
            ];
        } else if (item?.imageType == IMAGE_TYPE.MODEL && showType == 'bg') {
            return [
                {
                    key: '1',
                    label: showType == 'bg' ? '预设背景' : '预设模特',
                }
            ];
        } else {
            return [
                {
                    key: '1',
                    label: showType == 'bg' ? '预设背景' : '预设模特',
                },
                {
                    key: '2',
                    label: '本地上传',
                }
            ];
        }
    }, [item, showType])

    const handleClick = (item, type) => {
        if (!item || !type) return
        setItem(item)
        setShowType(type)
        setIsModalOpen(true)
    }

    const handleOk = async () => {
        if (!selectItemId || !item) return
        if (showType == 'model') {
            const res = await workflowOfChange(item.imageType, item.taskId, {
                modelKeyList: [selectItemObj]
            })
            if (!res) return
            const { disabled, pathname, options } = res
            if (disabled) {
                message.warning("版本更新，请重新编辑后再重新生成")
            } else {
                message.success('生成中，请稍后！')
                setGlobalTaskReadFlag(prev => !prev)
                props.fetchProjectDetail()
            }
        } else if (showType == 'bg') {
            const res = await workflowOfChange(item.imageType, item.taskId, {
                sceneKeyList: [selectItemObj]
            })
            if (!res) return
            const { disabled, pathname, options } = res
            if (disabled) {
                message.warning("版本更新，请重新编辑后再重新生成")
            } else {
                message.success('生成中，请稍后！')
                setGlobalTaskReadFlag(prev => !prev)
                props.fetchProjectDetail()
            }
        } else if (showType == 'video') {
            const res = await workflowOfChange(item.imageType, item.taskId, {
                videoKeyList: [selectItemObj]
            })
            if (!res) return
            const { disabled, pathname, options } = res
            if (disabled) {
                message.warning("版本更新，请重新编辑后再重新生成")
            } else {
                message.success('生成中，请稍后！')
                setGlobalTaskReadFlag(prev => !prev)
                props.fetchProjectDetail()
            }
        }
        setIsModalOpen(false)
    }

    const onCancel = () => {
        setIsModalOpen(false)
        setSelectItemId()
        setResourceFilter({
            sex: [], // 性别
            age: [], // 年龄
            skin: [], // 肤色
            shoesType: [], // 鞋子品类 
            pose: [], // 姿势
            clothesCate: [], // 服饰品类
            commodityType: null, // 商品品类 only commodity
            recommendCommodityType: null, // 推荐的商品品类 only commodity
            sceneType: null, // 场景品类 only commodity OR model
        })
    }

    useEffect(() => {
        if (!isModalOpen || showType == 'video') return
        getModelList()
        getBgList()
    }, [resourceFilter, isModalOpen])

    const getModelList = async () => {
        const { age, sex, skin } = resourceFilter
        // 预设模特
        const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.MODEL] }
        if (age?.length > 0) params.age = age?.join()
        if (sex?.length > 0) params.sex = sex?.join()
        if (skin?.length > 0) params.skin = skin?.join()
        const res = await API.getPresetResources2({ ...params, pageIndex: 1, pageSize: 50000 })
        if (res.code != 0) throw new Error(res.message)
        const list = res.data.items
            .filter(item => item.name != "00_default_style")
            .filter(item => !/_random$/.test(item.name) && item.name != "00_keep")
            .map(item => ({
                ...item,
                subList: item?.subList?.filter(item => !/_random$/.test(item.name))
            }))
        setModelList(list)

        // 自定义模特
        const params2 = { ...RESOURCE_PARAMS[RESOURCE_TYPE.MODEL] }
        const res2 = await API.getCustomResources2({ ...params2, pageIndex: 1, pageSize: 50000 })
        if (res2.code != 0) throw new Error(res.message)
        setCustomModelList(res2.data.items)
    }

    const getBgList = async () => {
        const { sceneType } = resourceFilter
        // 预设场景
        const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.MODEL_SCENE] }
        params.sceneType = sceneType
        const res = await API.getPresetResources2({ ...params, pageIndex: 1, pageSize: 50000 })
        if (res.code != 0) throw new Error(res.message)
        const list = res.data.items
            .filter(item => item.name != "00_default_style")
            .filter(item => !/_random$/.test(item.name) && item.name != "00_keep")
            .map(item => ({
                ...item,
                subList: item?.subList?.filter(item => !/_random$/.test(item.name))
            }))
        setBgList(list)

        // 自定义场景
        const params2 = { ...RESOURCE_PARAMS[RESOURCE_TYPE.MODEL_SCENE] }
        const res2 = await API.getCustomResources2({ ...params2, pageIndex: 1, pageSize: 50000 })
        if (res2.code != 0) throw new Error(res.message)
        setCustomBgList(res2.data.items)
    }

    useEffect(() => {
        if (!isModalOpen || showType != 'video') return
        getVideoList()
    }, [isModalOpen, showType])
    const getVideoList = async () => {
        // 预设场景
        const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.VIDEO_MODEL] }
        const res = await API.getPresetResources2({ ...params, pageIndex: 1, pageSize: 50000 })
        if (res.code != 0) throw new Error(res.message)
        const list = res.data.items
        setTryonVideoList(list)
    }


    const hdCost = useMemo(() => {
        return showType == 'video' ? (Math.round(selectCurrentItem?.attr?.duration / 1000) || 0) * (item.mode == GENERATE_MODE.HQ ? 40 : 25) : 10
    }, [showType, item, selectCurrentItem])

    const showList = useMemo(() => {
        if (showType == 'model') {
            return tabKey == '1' ? modelList : customModelList
        } else if (showType == 'bg') {
            return tabKey == '1' ? bgList : customBgList
        } else if (showType == 'video') {
            return tryonVideoList
        }
    }, [tabKey, showType, modelList, bgList, tryonVideoList])

    const resourceType = useMemo(() => {
        if (showType == 'model') {
            return RESOURCE_TYPE.MODEL
        } else if (showType == 'bg') {
            return RESOURCE_TYPE.MODEL_SCENE
        }
    }, [showType])

    const showFilter = useMemo(() => {
        if (tabKey == '1') {
            return true
        }
    }, [tabKey])

    const selectClick = (item) => {
        setSelectCurrentItem(item)
        const imageUrlWithVersion = Utils.addParamsToUrl(item.imageUrl, { version: item.attr.version })
        setSelectItemObj({
            key: item.name,
            title: item.attr.title,
            url: imageUrlWithVersion,
            custom: item.attr.custom ? 1 : 0,
        })
        setSelectItemId(item.id)
    }

    // 选择场景子项
    const updateShowList = (parentItem, selectedItem) => {
        if (showType === 'bg' && tabKey === '1') { // 仅预设背景
            setBgList(prevList =>
                prevList.map(item =>
                    item.id === parentItem.id ? { ...selectedItem, subList: item.subList } : item
                )
            )
        }
    }
    const [subList, setSubList] = useState([])
    const handlePopoverClick = (e, subList) => {
        e.stopPropagation()
        setSubList(subList)
    }
    const handleSelectPopover = (e, item, parentItem) => {
        e.stopPropagation()
        const imageUrlWithVersion = Utils.addParamsToUrl(item.imageUrl, { version: item.attr.version })
        setSelectItemObj({
            key: item.name,
            title: item.attr.title,
            url: imageUrlWithVersion,
            custom: item.attr.custom ? 1 : 0,
        })
        setSelectItemId(item.id)

        // 更新列表状态，用选中的子项替换父项
        updateShowList(parentItem, item)
    }

    const PopoverContent = (parentItem) => (
        <div className={styles.smallTabContent}>
            {
                subList.map((item) => {
                    return (
                        <div key={item.name}
                            onClick={(e) => handleSelectPopover(e, item, parentItem)}
                            className={`${styles.smallTabContentItem} ${selectItemId == item.id ? styles.smallTabContentItemActive : ''}`}>
                            <img src={Utils.getImgThumbnail(item.imageUrl)} alt="" />
                        </div>
                    )
                })
            }
        </div>
    )

    return (
        <Modal
            open={isModalOpen}
            title={showType == 'model' ? '选择容貌' : showType == 'video' ? '选择动作' : '选择背景'}
            footer={
                <div className={styles.Footer}>
                    <>
                        <Button style={{ marginRight: '12px' }}
                            onClick={() => setIsModalOpen(false)}
                        >放弃选择</Button>
                        <Button type="primary" onClick={handleOk}>生成
                            <img src={require('@assets/images/arcbean3.png')} />
                            <span>{hdCost}</span>
                        </Button>
                    </>
                </div>
            }
            maskClosable={true}
            closable={false}
            width="1100px"
            onCancel={onCancel}
        >
            <div className={styles.ChangeModel}>
                {showType != 'video' && <Tabs defaultActiveKey="1" items={tabItem} onChange={(key) => setTabKey(key)} />}
                {showFilter && <SelectionFilter resourceType={resourceType} />}
                <div className={`${styles.TabContent} _beauty_scrollbar`}>
                    {
                        showList?.map((item) => (
                            <div
                                key={item.id}
                                style={{ height: showType == 'video' ? 'auto' : '266px' }}
                                className={`${styles.TabContentItem} ${selectItemId == item.id ? styles.TabContentItemActive : ''}`}
                                onClick={() => selectClick(item)}>
                                {
                                    showType == 'video' ? <video
                                        src={item.imageUrl}
                                        key={item.id}
                                        loop
                                        autoPlay
                                        muted
                                        disablePictureInPicture
                                        type="video/mp4"></video> : <img src={Utils.getImgThumbnail(item.imageUrl)} alt="" />
                                }
                                {
                                    showType != 'video' && <p>{item?.attr?.title?.split('-').pop() || '未命名'}</p>
                                }
                                {
                                    item.subList?.length > 0 && <Popover
                                        placement="bottomLeft"
                                        arrow={false}
                                        styles={{ body: { padding: 0 } }}
                                        trigger={"click"}
                                        content={PopoverContent(item)}  // 传入父项
                                    >
                                        <div
                                            className={styles.TriggerItem}
                                            onClick={(e) => handlePopoverClick(e, item.subList)}>
                                            <Iconfont type="icon-SwitcherOutlined" />
                                        </div>
                                    </Popover>
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </Modal>
    )
})

export default ChangeModelAndBg